import { AnimatePresence, motion } from "motion/react";
import { FaArchive } from "react-icons/fa";
import { FaPeopleGroup, FaPeopleRoof, FaUserDoctor } from "react-icons/fa6";
import { IoHome } from "react-icons/io5";
import { Link, useNavigate } from "react-router";
import { useMutation } from "@tanstack/react-query";
import { ReactNode } from "react";
import { CiLogout } from "react-icons/ci";
import { MdAdminPanelSettings } from "react-icons/md";
import { useLocation } from "react-router";

import { CONSTANTS, RoutesType } from "../../../constants";
import useLogout from "../../../hooks/logoutHook";
import { fetcher } from "../../../network";
import { API } from "../../../network/api";

type ItemsType = { title: string; path: RoutesType; icon: ReactNode }[];

const Items: ItemsType = [
  { title: "בית", path: "/", icon: <IoHome size={20} color="#144082" /> },
  {
    title: "רופאים",
    path: "/doctors",
    icon: <FaUserDoctor size={20} color="#144082" />,
  },
  {
    title: "מלווים",
    path: "/guides",
    icon: <FaPeopleGroup size={20} color="#144082" />,
  },
  {
    title: "כניסה ויציאה - דיירים",
    path: "/ptients/enter-exit",
    icon: <FaPeopleRoof size={20} color="#144082" />,
  },
  {
    title: "ארכיון דיירים",
    path: "/archive",
    icon: <FaArchive size={20} color="#144082" />,
  },
  {
    title: "פאנל ניהול",
    path: "/admin-pannel",

    icon: <MdAdminPanelSettings size={20} color="#144082" />,
  },
  {
    title: "התנתק",
    path: "/login",
    icon: <CiLogout size={20} color="#144082" />,
  },
];

const logout = async () => {
  return await fetcher().post(API.POST.LOGOUT);
};

const Drawer = ({ toggleDrawer }: { toggleDrawer: () => void }) => {
  const navigate = useNavigate();
  const logoutFromHome = useLogout();

  const { mutate } = useMutation({
    mutationFn: logout,
    onSuccess: () => {
      logoutFromHome();
    },
  });

  const location = useLocation();

  return (
    <AnimatePresence>
      <>
        {/* Overlay */}
        <motion.div
          className="fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={toggleDrawer}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}></motion.div>

        {/* Drawer Content */}
        <motion.div
          className="fixed top-0 left-0 h-full w-3/4 max-w-sm bg-white shadow-lg z-50 flex flex-col"
          initial={{ x: "-100%" }}
          animate={{ x: 0 }}
          exit={{ x: "-100%" }}
          transition={{ type: "spring", stiffness: 300, damping: 30 }}>
          <div className="flex flex-col justify-between h-full">
            <div className="overflow-y-auto">
              <div className="p-4 flex justify-between items-center">
                <h3 className="text-lg font-bold">אפשרויות</h3>
                <button onClick={toggleDrawer}>✕ סגור</button>
              </div>
              <ul className="text-center divide-y">
                {Items.map(({ icon, path, title }) => (
                  <li
                    key={path}
                    className={`${
                      location.pathname === path ? "bg-blue-200" : ""
                    } py-6 hover:bg-gray-100 flex gap-2 items-center px-4 hover:cursor-pointer`}
                    onClick={() => {
                      if (path === CONSTANTS.ROUTES.login) {
                        mutate();
                      } else {
                        navigate(path);
                      }
                    }}>
                    {icon}
                    <Link to={path}>{title}</Link>
                  </li>
                ))}
              </ul>
            </div>
            <p className="text-center mb-2">version 1.0</p>
          </div>
        </motion.div>
      </>
    </AnimatePresence>
  );
};
export default Drawer;
